export const headers = {
    Authorization: 'Client-ID 52680c0415d6925',
};
